export default __webpack_public_path__ + "static/media/Deathmark.35e9dcc0.jpg";